import { 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot, 
    getCenteredCoordinateForAnimation, 
    line,
    LINE_ANIMATION_TIME 
} from '../../initials';
export class JumpFromDotToDotLineStartCenterTopRight {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotLineStartCenterTopRight',
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.TOP_RIGHT,
        };
    }

    getAnimationTime() {
        return LINE_ANIMATION_TIME;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, Math.PI / 4);

        return {
            x: line(
                startXY.x, 
                endXY.x, 
                t,
            ),
            y: line(
                startXY.y, 
                endXY.y, 
                t,
            ),
        };
    };
};